import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-agents-iframe',
  standalone: true,
  template: `
    <div class="w-full h-full border-none overflow-hidden" style="min-height: calc(100vh - 100px);">
      <iframe
        [src]="safeUrl"
        class="border-none"
        allow="autoplay; camera; microphone; fullscreen; display-capture; clipboard-read; clipboard-write"
      ></iframe>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AgentsIframeComponent {
  private static readonly FALLBACK_URL =
    'https://agents.paymefy.com/agents?tenant=01H3KTRAKX0XBQXCY59VGDP9KK';

  private sanitizer = inject(DomSanitizer);
  private route = inject(ActivatedRoute);
  public safeUrl: SafeResourceUrl;

  constructor() {
    const tenantId = this.route.snapshot.queryParams['tenant'];
    const url = tenantId
      ? `https://agents.paymefy.com/agents?tenant=${tenantId}`
      : AgentsIframeComponent.FALLBACK_URL;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
